const creditCardTypes = [
  'דיירקט',
  'כסף',
  'זהב',
  'פלטינום',
]

export default creditCardTypes
